import axios from "axios";
import { Message } from "element-ui";
import VueCookie from "@/config/util.cookies";
import router from "@/router";
import { Loading } from "element-ui";

let Axios = axios.create({
  withCredentials: true
});
let loader;
//Axios request 拦截器
Axios.interceptors.request.use(
  config => {
    loader = Loading.service({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    config.headers["Content-Type"] = "application/json;charset=utf-8";
    //获取本地存储的token
    const token = VueCookie.get("token");
    if (token !== null) {
      config.headers.Authorization = "Bearer " + token; //携带权限参数
    } else {
      router.push("/ssoLogin");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
//Axios response 拦截器
Axios.interceptors.response.use(
  response => {
    loader.close();
    const responseType = response.config[0];
    //判断是否为导出数据
    if (responseType !== "blob") {
      if (response.data.status === 200) {
        return Promise.resolve(response);
      } else {
        Message.error({
          message: response.data.msg,
          duration: 3000
        });
        return Promise.reject(response);
      }
    } else {
      return response.data;
    }
  },
  error => {
    loader.close();
    if (error.response.data.status === 401) {
      Message.error({
        message: "您无权访问当前资源!",
        duration: 3000
      });
    } else {
      Message.error({
        message: error.response.data.msg,
        duration: 3000
      });
    }
    return Promise.reject(error);
  }
);
export default {
  get: function(url, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.get(url, {
        params: params
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  post: function(url, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.post(url, JSON.stringify(params))
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  put: function(url, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.put(url, params).then(response => {
        if (response) {
          resolve(response.data);
        } else {
          reject("error");
        }
      });
    });
  },
  patch: function(url, params = {}) {
    return new Promise((resolve, reject) => {
      Axios.patch(url, params).then(response => {
        if (response) {
          resolve(response.data);
        } else {
          reject("error");
        }
      });
    });
  },
  getLoad: function() {
    return Loading.service({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
  },
  exportExcel(tHeader, filter, list, title) {
    let _this = this;
    require.ensure([], () => {
      const { export_json_to_excel } = require("@/config/Excel/Export2Excel"); //注意这个Export2Excel路径
      const data = _this.formatJson(filter, list);
      export_json_to_excel(tHeader, data, title); //最后一个是表名字
    });
  },
  formatJson(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]));
  }
};
